import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ProductAdjustmentModel,
  ProductAdjustmentMutationDeleteInput,
  ProductAdjustmentMutationInput,
  ProductAdjustmentMutationUpdateInput,
} from './model';

export function useCreateProductAdjustment(
  options?: UseMutationOptions<
    ApiResult<ProductAdjustmentModel>,
    ApiError,
    ProductAdjustmentMutationInput
  >,
) {
  return useMutation<
    ApiResult<ProductAdjustmentModel>,
    ApiError,
    ProductAdjustmentMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'product-adjustments',
      method: 'POST',
      body,
      classType: ProductAdjustmentModel,
    });
  }, options);
}

export function useUpdateProductAdjustment(
  option?: UseMutationOptions<
    ApiResult<ProductAdjustmentModel>,
    ApiError,
    ProductAdjustmentMutationUpdateInput
  >,
) {
  return useMutation<
    ApiResult<ProductAdjustmentModel>,
    ApiError,
    ProductAdjustmentMutationUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `product-adjustments/${body.id}`,
      method: 'PUT',
      body: body.body,
      classType: ProductAdjustmentModel,
    });
  }, option);
}

export function useDeleteProductAdjustment(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    ProductAdjustmentMutationDeleteInput
  >,
) {
  return useMutation<
    ApiResult<any>,
    ApiError,
    ProductAdjustmentMutationDeleteInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `product-adjustments/${body.id}`,
      method: 'DELETE',
    });
  }, options);
}
